<template>

  <div :class="[$style.row, isMobile && $style.mobileRow]">
      <slot/>
  </div>

</template>

<style lang="scss" module>

.row {
  width: 100%;
  line-height:40px;


}

.mobileRow {
  p {font-size:14px;}

  h5 { 
    font-weight: 500;
    font-size:15px;
    padding-bottom: 12px;
    border-bottom: 1px solid #cccccc
  }
}
  
</style>


<script>
import { mapState } from 'vuex'

export default {
  name: "listCard",

  data() {
    return {
     windowWidth: 0,
     fullHeight: 0
    }
  },

  computed: {
    ...mapState({
      isMobile: state => state.ui.isMobile
    }),
  },

  props: {
    quality: {
      type: Array,
    }
  }  
}

</script>

